import { render, staticRenderFns } from "./PagePayArrange.vue?vue&type=template&id=71e760ac&scoped=true&"
import script from "./PagePayArrange.vue?vue&type=script&lang=js&"
export * from "./PagePayArrange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e760ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e760ac')) {
      api.createRecord('71e760ac', component.options)
    } else {
      api.reload('71e760ac', component.options)
    }
    module.hot.accept("./PagePayArrange.vue?vue&type=template&id=71e760ac&scoped=true&", function () {
      api.rerender('71e760ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/payarrange/PagePayArrange.vue"
export default component.exports